import React from "react";
import { Link } from "react-router-dom";

export function Logo({ className = "h-9" }) {
  return (
    <Link to="/" data-testid="logo-home-link" className="inline-flex items-center">
      <img src="/logo.webp" alt="GetJobs.Today" className={className} />
    </Link>
  );
}
